export * from './provider'

export default (state, action) => {
  switch (action.type) {
    case 'setSecondaryNav':
      return {
        ...state,
        secondaryNav: action.value
      };
      
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/nav/index.js